var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('span',{staticClass:"spinner-border spinner-border-sm"}):_c('NbSelectInput',{attrs:{"options":_vm.boxes,"id":"select-action"},model:{value:(_vm.actionValue),callback:function ($$v) {_vm.actionValue=$$v},expression:"actionValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }